import { createClient } from 'contentful';

const CONTENTFUL_SPACE_ID = process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID;
const CONTENTFUL_ACCESS_TOKEN = process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN;

// Check if Contentful is configured
const isContentfulConfigured = !!(
  CONTENTFUL_SPACE_ID && CONTENTFUL_ACCESS_TOKEN
);

if (!isContentfulConfigured) {
  console.warn(
    'Contentful is not configured. Release notes will not be available.'
  );
}

// Create client only if properly configured, otherwise create a mock client
export const contentfulClient = isContentfulConfigured
  ? createClient({
      space: CONTENTFUL_SPACE_ID!,
      accessToken: CONTENTFUL_ACCESS_TOKEN!,
    })
  : null;

// Export flag to check if Contentful is available
export const isContentfulAvailable = isContentfulConfigured;

export type { Document } from '@contentful/rich-text-types';
export * from './hooks';
export { clearContentfulCache } from './persister';
export * from './rich-text-renderer';
export * from './types';
export * from './utils';
